import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const DiscountIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg viewBox="0 0 16 16" ref={ref} {...props}>
          <path
            d="M9 2H14V7L8 13L3 8L9 2Z"
            stroke="currentColor"
            fill="none"
            strokeLinecap="square"
            strokeLinejoin="miter"
          />
          <circle cx="11.5" cy="4.5" r="0.75" fill="currentColor" />
        </svg>
      </Icon>
    );
  },
);

DiscountIcon.displayName = "DiscountIcon";
